import googleIcon from './google.svg'
import priceIcon from './price.svg'
import calendarIcon from './calendar.svg'
import tickIcon from './tick.svg'
import momo from './momo.png'
import vnpay from './vnpay.png'
import atm from './atm.svg'
import calendarGreenIcon from './calendarGreen.svg'
import locationIcon from './location.svg'
import priceGreenIcon from './priceGreen.svg'
import minusIcon from './minus1.svg'
import plusIcon from './plus1.svg'
import cart from './cart.png'

const icon = {
    googleIcon,
    priceIcon,
    calendarIcon,
    tickIcon,
    momo,
    atm,
    vnpay,
    calendarGreenIcon,
    locationIcon,
    priceGreenIcon,
    minusIcon,
    plusIcon,
    cart
}

export default icon;